import { Injectable, NgZone } from '@angular/core';
import { from } from 'rxjs';
import { Router } from '@angular/router';
import { ApiResponse, HttpService } from './http.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private accessKey = 'access_token';
  private userKey = 'current_user';
  public moveonKey = 'move0n_s';
  public Batchnum = "";

  constructor(
    private http: HttpService,
    public router: Router,
    public ngZone: NgZone
  ) { }

  // Sign-out
  signOut() {
    localStorage.clear();
    this.http.setJwtError(false);
    this.router.navigate(['/user/login']);
  }

  setToken(accesToken: string) {
    localStorage.setItem(this.accessKey, accesToken);
  }

  getToken() {
    return localStorage.getItem(this.accessKey);
  }

  get isLoggedIn(): boolean {
    const token = localStorage.getItem(this.accessKey);
    const user = localStorage.getItem(this.userKey);
    return (!token || token === null || !user || user === null) ? false : true;
  }

  setUser(currentUser: any) {
    localStorage.setItem(this.userKey, JSON.stringify(currentUser));
  }

  getUser() {
    return JSON.parse(localStorage.getItem(this.userKey));
  }

  connectAPI(path: string, credentials: any) {
    return from(this.http.requestPost(path, credentials));
  }

  async connectAPI_AsyncAwait(path: string, credentials: any): Promise<ApiResponse> {
    return await this.http.requestPost(path, credentials);
  }

  async connectAPI_Net(path: string, credentials: any): Promise<ApiResponse> {
    return await this.http.requestPostApi(path, credentials);
  }

  loadFile(path: string, credentials: any) {
    return from(this.http.requestPostBlob(path, credentials));
  }

}